import apiClient from './axiosClient';

export const downloadReport = async (url, params = {}, preferredFilename = null) => {
  const response = await apiClient.get(url, {
    params,
    responseType: 'blob',
  });

  const disposition = response.headers['content-disposition'];
  const filenameMatch = disposition?.match(/filename="?([^"]+)"?/i);

  return {
    blob: response.data,
    filename: preferredFilename || (filenameMatch ? filenameMatch[1] : 'report'),
  };
};
